// Generated by purs version 0.14.3
"use strict";
var Data_Function = require("../Data.Function/index.js");
var Data_Show = require("../Data.Show/index.js");
var Network_Ethereum_Web3_Solidity_Size = require("../Network.Ethereum.Web3.Solidity.Size/index.js");
var Type_Proxy = require("../Type.Proxy/index.js");
var EncodingType = function (isDynamic, typeName) {
    this.isDynamic = isDynamic;
    this.typeName = typeName;
};
var typeName = function (dict) {
    return dict.typeName;
};
var isDynamic = function (dict) {
    return dict.isDynamic;
};
var encodingTypeVector = function (dictKnownSize) {
    return function (dictEncodingType) {
        return new EncodingType(Data_Function["const"](isDynamic(dictEncodingType)(Type_Proxy["Proxy"].value)), (function () {
            var n = Data_Show.show(Data_Show.showInt)(Network_Ethereum_Web3_Solidity_Size.sizeVal(dictKnownSize)(Network_Ethereum_Web3_Solidity_Size.DLProxy.value));
            var baseTypeName = typeName(dictEncodingType)(Type_Proxy["Proxy"].value);
            return Data_Function["const"](baseTypeName + ("[" + (n + "]")));
        })());
    };
};
var encodingTypeUIntN = function (dictIntSize) {
    return new EncodingType(Data_Function["const"](false), Data_Function["const"]("uint" + Data_Show.show(Data_Show.showInt)(Network_Ethereum_Web3_Solidity_Size.sizeVal(dictIntSize.KnownSize0())(Network_Ethereum_Web3_Solidity_Size.DLProxy.value))));
};
var encodingTypeTagged = function (dictEncodingType) {
    return new EncodingType(function (v) {
        return isDynamic(dictEncodingType)(Type_Proxy["Proxy"].value);
    }, function (v) {
        return typeName(dictEncodingType)(Type_Proxy["Proxy"].value);
    });
};
var encodingTypeString = new EncodingType(Data_Function["const"](true), Data_Function["const"]("string"));
var encodingTypeIntN = function (dictIntSize) {
    return new EncodingType(Data_Function["const"](false), Data_Function["const"]("int" + Data_Show.show(Data_Show.showInt)(Network_Ethereum_Web3_Solidity_Size.sizeVal(dictIntSize.KnownSize0())(Network_Ethereum_Web3_Solidity_Size.DLProxy.value))));
};
var encodingTypeInt = new EncodingType(Data_Function["const"](false), Data_Function["const"]("int"));
var encodingTypeBytesD = new EncodingType(Data_Function["const"](true), Data_Function["const"]("bytes[]"));
var encodingTypeBytes = function (dictKnownSize) {
    return new EncodingType(Data_Function["const"](false), (function () {
        var n = Data_Show.show(Data_Show.showInt)(Network_Ethereum_Web3_Solidity_Size.sizeVal(dictKnownSize)(Network_Ethereum_Web3_Solidity_Size.DLProxy.value));
        return Data_Function["const"]("bytes[" + (n + "]"));
    })());
};
var encodingTypeBoolean = new EncodingType(Data_Function["const"](false), Data_Function["const"]("bool"));
var encodingTypeBigNumber = new EncodingType(Data_Function["const"](false), Data_Function["const"]("int"));
var encodingTypeArray = function (dictEncodingType) {
    return new EncodingType(Data_Function["const"](true), Data_Function["const"]("[]"));
};
var encodingTypeAddress = new EncodingType(Data_Function["const"](false), Data_Function["const"]("address"));
module.exports = {
    EncodingType: EncodingType,
    typeName: typeName,
    isDynamic: isDynamic,
    encodingTypeBoolean: encodingTypeBoolean,
    encodingTypeInt: encodingTypeInt,
    encodingTypeBigNumber: encodingTypeBigNumber,
    encodingTypeUIntN: encodingTypeUIntN,
    encodingTypeIntN: encodingTypeIntN,
    encodingTypeString: encodingTypeString,
    encodingTypeAddress: encodingTypeAddress,
    encodingTypeArray: encodingTypeArray,
    encodingTypeBytes: encodingTypeBytes,
    encodingTypeVector: encodingTypeVector,
    encodingTypeBytesD: encodingTypeBytesD,
    encodingTypeTagged: encodingTypeTagged
};
